<template lang="pug">
  div
    form#customerInfo(@submit.prevent="onSubmit")
      .row
        .xs-6
          mr-input(label="First name" v-model="first_name" :v="$v.first_name" required dataMrAss="profile-firstname").pr-5

        .xs-6
          mr-input(label="Last name" v-model="last_name" :v="$v.last_name" required dataMrAss="profile-lastname").pl-5

      .row
        .xs-12
          mr-input(label="Email" input-type="email" v-model="email" :v="$v.email" required dataMrAss="profile-email")

      .row
        .xs-12
          mr-phone-input(label="Phone" input-type="tel" v-model="phone_main" :v="$v.phone_main" data-mr-ass="profile-phone-main")

      .row
        .xs-12
          mr-phone-input(label="Mobile" input-type="tel" v-model="phone_mobile" :v="$v.phone_mobile" data-mr-ass="profile-phone-mobile")

      .row
        h4.bold.mt-20.mb-10 Birthday
        .birthday-inputs.mb-15
          .birthday-input.xs-5.md-4
            dropdown(label="Month" v-model='birthday_month' :disabled="disableBirthday" data-mr-ass="birthday-dropdown-month")
              option(v-for="option in months" :value="option.value" :key="option.value") {{ option.label }}

          .birthday-input.xs-4.md-3
            dropdown(label="Day" v-model="birthday_day" :disabled="disableBirthday" data-mr-ass="birthday-dropdown-day")
              option(v-for="option in days" :value="option.label" :key="option.value") {{ option.label }}

          .xs-2.birthday-info(v-if="disableBirthday")
            i.icon-info.xs-f-xmedium.max-at-tweak.color-mr-purple(v-tooltip="birthdayTooltip")

      .row
        .text-center
          button.mr-btn.btn-fixed-width.font-xsmall(data-mr-ass="save-account") Save

</template>

<script>
  const { required, minLength, email } = require("vuelidate/lib/validators");

  import { mapGetters } from 'vuex';
  import { mrPhoneValidator } from '../../../utilities/customValidators';

  import mrInput from '../../mrInput';
  import mrPhoneInput from '../../mrPhoneInput.vue';

  export default {
    name: "CustomerForm",

    components: {
      mrInput,
      mrPhoneInput
    },

    data() {
      return {
        birthdayTooltip: {
          placement: 'bottom',
          content: `To update your birthday, please call ${MR.config.contactPhone}`,
          class: "vue-tooltip-padded"
        },

        months: [
          { label: null, value: 0 },
          { label: 'January', value: 1 },
          { label: 'February', value: 2 },
          { label: 'March', value: 3 },
          { label: 'April', value: 4 },
          { label: 'May', value: 5 },
          { label: 'June', value: 6 },
          { label: 'July', value: 7 },
          { label: 'August', value: 8 },
          { label: 'September', value: 9 },
          { label: 'October', value: 10 },
          { label: 'November', value: 11 },
          { label: 'December', value: 12 }
        ]
      }
    },

    computed: {
      ...mapGetters('customer', [
        'disableBirthday'
      ]),

      days() {
        var days = [{label: null, value: null}];
        var month = this.birthday_month || 1;

        var numDays = new Date(1896, month, 0).getDate();
        for (var x = 1; x <= numDays; x++) {
          days.push({label: '' + x, value: x});
        }

        if (this.birthday_day > numDays) {
          this.birthday_day = null;
        }

        return days;
      },

      first_name: {
        get() {
          return this.$store.state.customer.customerEditForm.first_name;
        },

        set(val) {
          this.$store.commit('customer/setFirstName', val);
        }
      },

      last_name: {
        get() {
          return this.$store.state.customer.customerEditForm.last_name;
        },

        set(val) {
          this.$store.commit('customer/setLastName', val);
        }
      },

      email: {
        get() {
          return this.$store.state.customer.customerEditForm.email;
        },

        set(val) {
          this.$store.commit('customer/setEmail', val);
        }
      },

      phone_main: {
        get() {
          return this.$store.state.customer.customerEditForm.phone_main;
        },

        set(val) {
          this.$store.commit('customer/setPhoneMain', val);
        }
      },

      phone_mobile: {
        get() {
          return this.$store.state.customer.customerEditForm.phone_mobile;
        },

        set(val) {
          this.$store.commit('customer/setPhoneMobile', val);
        }
      },

      birthday_day: {
        get() {
          return this.$store.state.customer.customerEditForm.birthday_day;
        },

        set(val) {
          this.$store.commit('customer/setBirthdayDay', val);
          this.$store.dispatch('customer/updateBirthday');
        }
      },

      birthday_month: {
        get() {
          return this.$store.state.customer.customerEditForm.birthday_month;
        },

        set(val) {
          this.$store.commit('customer/setBirthdayMonth', val);
          this.$store.dispatch('customer/updateBirthday');
        }
      }
    },

    validations: {
      first_name: {
        minLength: minLength(2),
        required
      },

      last_name: {
        minLength: minLength(2),
        required
      },

      email: {
        required,
        email
      },

      phone_main: {
        mrPhoneValidator,
        required
      },

      phone_mobile: {
        mrPhoneValidator
      }
    },

    methods: {
      onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.$store.dispatch('customer/updateCustomer');
      }
    }
  }
</script>

<style scoped lang="stylus">
  button
    margin 2em 0em

  .birthday-input
    display inline-block
    margin-right 0.5em
    vertical-align top

  .birthday-info
    padding-top 1em

</style>